export default __webpack_public_path__ + "static/parkBench-f9814080df28a81e443fdfda0ee3ff36.webp";